import BundleVideos from '@/entry/js-pdp-bundle-videos'

document.addEventListener('DOMContentLoaded', () => {
	new BundleVideos()
})